import { render, staticRenderFns } from "./SecondParagraph.vue?vue&type=template&id=374e32e6&"
import script from "./SecondParagraph.vue?vue&type=script&lang=js&"
export * from "./SecondParagraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports